define('SuiteCommerce.ItemBadges.ProductDetail', [
  'SuiteCommerce.ItemBadges.View'
], function ItemBadgesProductDetail(
  ItemBadgesView
) {
  'use strict';
  return {
    loadProductDetailItemBadges: function loadProductDetailItemBadges(application, collection) {
      var pdp = application.getComponent('PDP');
      this.addProductDetailChildViews(pdp, collection);
    },
    addProductDetailChildViews: function addProductDetailChildViews(pdp, collection) {
      pdp.addChildViews(
        pdp.PDP_FULL_VIEW, {
          'Product.ImageGallery': {
            'Itembadges.View': {
              childViewIndex: 5,
              childViewConstructor: function childViewConstructor() {
                return new ItemBadgesView({
                  view: 'pdp',
                  items: pdp.getItemInfo(),
                  collection: collection
                });
              }
            }
          }
        }
      );
      pdp.addChildViews(
        pdp.PDP_QUICK_VIEW, {
          'Product.ImageGallery': {
            'Itembadges.View': {
              childViewIndex: 5,
              childViewConstructor: function childViewConstructor() {
                return new ItemBadgesView({
                  view: 'pdp',
                  items: pdp.getItemInfo(),
                  collection: collection
                });
              }
            }
          }
        }
      );
    }
  };
});
